import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Speakers.css';
import { siteConfig } from './config';

const speakersData = [
  {
    name: "Dr. Abha Chandra",
    topic: "Smoking Cessation in PAD - Underused weapon",
    session: "Session I: Vascular Medicine",
    day: "Day 1 - Friday, 13th March 2026",
    time: "1:30 PM - 2:30 PM"
  },
  {
    name: "Dr. Adarsh Kabra",
    topic: "Different Imaging modalities - Microscopic view",
    session: "Session I: Vascular Medicine",
    day: "Day 1 - Friday, 13th March 2026",
    time: "1:30 PM - 2:30 PM"
  },
  {
    name: "Dr. Adarsh Kabra",
    topic: "Management of chronic total occlusions - Beyond the block",
    session: "Session I: Clinical Strategies",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "9:00 AM - 10:00 AM"
  },
  {
    name: "Dr. Ajay Dabbas",
    topic: "Imaging innovations: IVUS and OCT - Depth meets detail",
    session: "Session VII: Innovations and Future Directions",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "3:10 PM - 4:20 PM"
  },
  {
    name: "Dr. Ajay Yadav",
    topic: "Bare metal vs Covered stents - Bare vs Bound",
    session: "Session III: Endovascular Suite",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "10:50 AM - 11:30 AM"
  },
  {
    name: "Dr. Apura Srivastav",
    topic: "Long term patency rates after endovascular therapy - Endovascular Durability",
    session: "Session VI: Outcomes and Evidences",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "2:00 PM - 3:10 PM"
  },
  {
    name: "Dr. Arunagiri V",
    topic: "Open vs Endovascular First - Open back or Fast track",
    session: "Session IV: Decision-Making And Controversies",
    day: "Day 1 - Friday, 13th March 2026",
    time: "4:50 PM - 5:30 PM"
  },
  {
    name: "Dr. Chandra Shekar A. R",
    topic: "When endo and open fails - The untameable lion",
    session: "Session I: Clinical Strategies",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "9:00 AM - 10:00 AM"
  },
  {
    name: "Dr. Chandra Shekar A. R",
    topic: "HawkOne Workshop",
    session: "Pre-conference Workshop",
    day: "Day 1 - Friday, 13th March 2026",
    time: "11:00 AM - 1:00 PM"
  },
  {
    name: "Col. Dr. Kumud Rai",
    topic: "Limb Salvage outcomes following intervention - Walking away from Amputation",
    session: "Session VI: Outcomes and Evidences",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "2:00 PM - 3:10 PM"
  },
  {
    name: "Dr. Deepak S",
    topic: "Atherectomy - Shave- shape - save",
    session: "Session IV: Advanced Inventory",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "11:30 AM - 12:30 PM"
  },
  {
    name: "Dr. Devender S",
    topic: "The Role of Open Surgery in the Era of DCB's and Stents - Old wisdom",
    session: "Session IV: Decision-Making And Controversies",
    day: "Day 1 - Friday, 13th March 2026",
    time: "4:50 PM - 5:30 PM"
  },
  {
    name: "Dr. Dhanesh K (Virtual)",
    topic: "Biodegradable scaffolds - Scaffold today, gone tomorrow",
    session: "Session IV: Advanced Inventory",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "11:30 AM - 12:30 PM"
  },
  {
    name: "Dr. Digvijay Singh",
    topic: "Long-Term Patency: What the Data Says - Build to Last",
    session: "Session V: Outcomes And Innovations",
    day: "Day 1 - Friday, 13th March 2026",
    time: "5:30 PM - 6:10 PM"
  },
  {
    name: "Dr. Diwakar B",
    topic: "Endarterectomy: A Lost Art or a Viable Option? - Art of the open solution",
    session: "Session III: Technique-Focused Deep Dives",
    day: "Day 1 - Friday, 13th March 2026",
    time: "3:50 PM - 4:50 PM"
  },
  {
    name: "Dr. Elan C",
    topic: "Endovascular therapy in resource limited settings - Maximise miles on budget",
    session: "Session VI: Outcomes and Evidences",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "2:00 PM - 3:10 PM"
  },
  {
    name: "Dr. Elancherlathan",
    topic: "Reoperating Femoropopliteal Region - Hostile battle field",
    session: "Session III: Technique-Focused Deep Dives",
    day: "Day 1 - Friday, 13th March 2026",
    time: "3:50 PM - 4:50 PM"
  },
  {
    name: "Dr. Gnaneshwar A",
    topic: "Global treatment algorithms - Precision care defined",
    session: "Session I: Clinical Strategies",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "9:00 AM - 10:00 AM"
  },
  {
    name: "Dr. Harishankar Nair",
    topic: "Lumiguide - Radiation free revolution",
    session: "Session VII: Innovations and Future Directions",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "3:10 PM - 4:20 PM"
  },
  {
    name: "Dr. Harshavardhan Oak",
    topic: "Lipid-Lowering agents - Beyond Statins",
    session: "Session I: Vascular Medicine",
    day: "Day 1 - Friday, 13th March 2026",
    time: "1:30 PM - 2:30 PM"
  },
  {
    name: "Dr. Hemanth",
    topic: "Pharmacotherapy - Unlocking Circulation Medically",
    session: "Session I: Vascular Medicine",
    day: "Day 1 - Friday, 13th March 2026",
    time: "1:30 PM - 2:30 PM"
  },
  {
    name: "Dr. Ilaya Kumar",
    topic: "Technical Pearls in Bypass - Flow without Friction",
    session: "Session III: Technique-Focused Deep Dives",
    day: "Day 1 - Friday, 13th March 2026",
    time: "3:50 PM - 4:50 PM"
  },
  {
    name: "Dr. Ilaya Kumar",
    topic: "Access and Access related complications - Safety First",
    session: "Session I: Clinical Strategies",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "9:00 AM - 10:00 AM"
  },
  {
    name: "Dr. Luv Luthra",
    topic: "Vasculomimetic stents",
    session: "Session IV: Advanced Inventory",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "11:30 AM - 12:30 PM"
  },
  {
    name: "Dr. Manvendu Jha",
    topic: "Global perspectives on skill development - Skills that sustain",
    session: "Session VII: Innovations and Future Directions",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "3:10 PM - 4:20 PM"
  },
  {
    name: "Dr. Marco Manzi (Virtual)",
    topic: "Endovascular approaches for complex diseases - Navigating the maze",
    session: "Session II: Decision Making",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "10:00 AM - 10:40 AM"
  },
  {
    name: "Dr. Murali Krishna",
    topic: "Retrograde access - Rethinking the Approach",
    session: "Session V: Techniques",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "12:30 PM - 1:30 PM"
  },
  {
    name: "Dr. N. Meda",
    topic: "Redo interventions - Rewiring the recurrences",
    session: "Session II: Decision Making",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "10:00 AM - 10:40 AM"
  },
  {
    name: "Dr. N. Shekar",
    topic: "Next generation drug technologies - The limus Leap",
    session: "Session VII: Innovations and Future Directions",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "3:10 PM - 4:20 PM"
  },
  {
    name: "Dr. N. Sritharan",
    topic: "Persistent Sciatic Artery, PSA PAES",
    session: "Session II: Core Surgical Topics",
    day: "Day 1 - Friday, 13th March 2026",
    time: "2:30 PM - 3:40 PM"
  },
  {
    name: "Dr. Nandan Haldipur",
    topic: "Intraoperative Imaging and Flow Assessment - Visualising Success",
    session: "Session III: Technique-Focused Deep Dives",
    day: "Day 1 - Friday, 13th March 2026",
    time: "3:50 PM - 4:50 PM"
  },
  {
    name: "Dr. P.C. Gupta",
    topic: "Antiplatelets and Antithrombotics - COMPASS to VOYAGER",
    session: "Session I: Vascular Medicine",
    day: "Day 1 - Friday, 13th March 2026",
    time: "1:30 PM - 2:30 PM"
  },
  {
    name: "Dr. Pratap Kumar S",
    topic: "Hardware - Smart solutions for tough vessels",
    session: "Session III: Endovascular Suite",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "10:50 AM - 11:30 AM"
  },
  {
    name: "Dr. Praveen Jindal",
    topic: "Predictors of Restenosis - Visualising risk",
    session: "Session VI: Outcomes and Evidences",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "2:00 PM - 3:10 PM"
  },
  {
    name: "Dr. Pritee Sharma",
    topic: "Endovascular vs Surgical Bypass - Wires vs Knives",
    session: "Session II: Decision Making",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "10:00 AM - 10:40 AM"
  },
  {
    name: "Dr. R. Shekar",
    topic: "When Open Complements Endovascular Therapy - Uniting techniques",
    session: "Session III: Technique-Focused Deep Dives",
    day: "Day 1 - Friday, 13th March 2026",
    time: "3:50 PM - 4:50 PM"
  },
  {
    name: "Dr. R. Tripathi (Virtual)",
    topic: "In-stent stenosis and occlusions - Taming the Neointima",
    session: "Session II: Decision Making",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "10:00 AM - 10:40 AM"
  },
  {
    name: "Dr. R.C. Sree Kumar",
    topic: "Anatomy & Exposure of Popliteal artery - Targeting the knee pit",
    session: "Session II: Core Surgical Topics",
    day: "Day 1 - Friday, 13th March 2026",
    time: "2:30 PM - 3:40 PM"
  },
  {
    name: "Dr. Radhakrishnanan Raju",
    topic: "Composite sequential profundal vein - Hitch hike technique",
    session: "Session III: Technique-Focused Deep Dives",
    day: "Day 1 - Friday, 13th March 2026",
    time: "3:50 PM - 4:50 PM"
  },
  {
    name: "Dr. Raghu M (Virtual)",
    topic: "Re-entry devices - Targeting the true lumen",
    session: "Session IV: Advanced Inventory",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "11:30 AM - 12:30 PM"
  },
  {
    name: "Dr. Rahul N.S",
    topic: "Embolic Protection Devices - Catch me if you can",
    session: "Session IV: Advanced Inventory",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "11:30 AM - 12:30 PM"
  },
  {
    name: "Dr. Rajesh S",
    topic: "Conduits and Anastomotic Techniques - Bridging the gap with precision",
    session: "Session II: Core Surgical Topics",
    day: "Day 1 - Friday, 13th March 2026",
    time: "2:30 PM - 3:40 PM"
  },
  {
    name: "Dr. Robbie George",
    topic: "IVL - Breaking the calcium ceiling",
    session: "Session IV: Advanced Inventory",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "11:30 AM - 12:30 PM"
  },
  {
    name: "Dr. S. Robinson",
    topic: "Open Bypass Surgery Techniques - Reclaim your stride",
    session: "Session II: Core Surgical Topics",
    day: "Day 1 - Friday, 13th March 2026",
    time: "2:30 PM - 3:40 PM"
  },
  {
    name: "Dr. Sairam S",
    topic: "Target Selection in Distal Bypass - The Right spot",
    session: "Session II: Core Surgical Topics",
    day: "Day 1 - Friday, 13th March 2026",
    time: "2:30 PM - 3:40 PM"
  },
  {
    name: "Dr. Sanjay Desai",
    topic: "Drug Coated Balloons vs Drug Eluting Stents - War on Hyperplasia",
    session: "Session III: Endovascular Suite",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "10:50 AM - 11:30 AM"
  },
  {
    name: "Dr. Shanmugam V",
    topic: "Techniques to avoid graft infection - Graft Defense",
    session: "Session III: Technique-Focused Deep Dives",
    day: "Day 1 - Friday, 13th March 2026",
    time: "3:50 PM - 4:50 PM"
  },
  {
    name: "Dr. Sharmila Suresh",
    topic: "Catheterisation Laboratory - Our Second Home",
    session: "Session III: Endovascular Suite",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "10:50 AM - 11:30 AM"
  },
  {
    name: "Dr. Shivanesan",
    topic: "Anatomy & Exposure of CFA-SFA-PFA - Mastering the Groin",
    session: "Session II: Core Surgical Topics",
    day: "Day 1 - Friday, 13th March 2026",
    time: "2:30 PM - 3:40 PM"
  },
  {
    name: "Dr. Siddharath V",
    topic: "When Endovascular Fails! - Turn to the knife when the wire fails",
    session: "Session IV: Decision-Making And Controversies",
    day: "Day 1 - Friday, 13th March 2026",
    time: "4:50 PM - 5:30 PM"
  },
  {
    name: "Dr. Sumit Kapadia",
    topic: "Next Generation Grafts - Seamless connections",
    session: "Session V: Outcomes And Innovations",
    day: "Day 1 - Friday, 13th March 2026",
    time: "5:30 PM - 6:10 PM"
  },
  {
    name: "Dr. Sumanth Raj",
    topic: "Closure Devices - Patching the hole",
    session: "Session IV: Advanced Inventory",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "11:30 AM - 12:30 PM"
  },
  {
    name: "Dr. Sundar N",
    topic: "Role of lesion length and morphology - Lesion complexity decoded",
    session: "Session I: Clinical Strategies",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "9:00 AM - 10:00 AM"
  },
  {
    name: "Dr. Sunil R",
    topic: "Managing ostial lesions - where it all begins",
    session: "Session V: Techniques",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "12:30 PM - 1:30 PM"
  },
  {
    name: "Dr. Tapsha Sahu",
    topic: "When to intervene? - Time is tissue",
    session: "Session II: Core Surgical Topics",
    day: "Day 1 - Friday, 13th March 2026",
    time: "2:30 PM - 3:40 PM"
  },
  {
    name: "Dr. Tarun Grover",
    topic: "CFA Stenting - The New Frontier",
    session: "Session V: Techniques",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "12:30 PM - 1:30 PM"
  },
  {
    name: "Dr. V.S. Bedi",
    topic: "Training the Next Generation - Modern Vascular Specialists",
    session: "Session V: Outcomes And Innovations",
    day: "Day 1 - Friday, 13th March 2026",
    time: "5:30 PM - 6:10 PM"
  },
  {
    name: "Dr. V.S. Bedi",
    topic: "Stent Fracture Management - The Broken Bridge",
    session: "Session II: Decision Making",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "10:00 AM - 10:40 AM"
  },
  {
    name: "Dr. Velladuraichi B",
    topic: "Autologous Vein vs Prosthetic Grafts - The optimal conduit question",
    session: "Session II: Core Surgical Topics",
    day: "Day 1 - Friday, 13th March 2026",
    time: "2:30 PM - 3:40 PM"
  },
  {
    name: "Dr. Vembu Anand",
    topic: "Patient Selection for Bypass: Beyond Guidelines - The Tailored Bypass",
    session: "Session IV: Decision-Making And Controversies",
    day: "Day 1 - Friday, 13th March 2026",
    time: "4:50 PM - 5:30 PM"
  },
  {
    name: "Dr. Venky Ramaiah",
    topic: "Percutaneous Transmural Arterial Bypass - The Inside out Bypass",
    session: "Session V: Techniques",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "12:30 PM - 1:30 PM"
  },
  {
    name: "Dr. Vijay Takore",
    topic: "Cost effectiveness of open Vs Endovascular procedures",
    session: "Session VI: Outcomes and Evidences",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "2:00 PM - 3:10 PM"
  },
  {
    name: "Dr. Vishal Bulla",
    topic: "AI in predicting re-stenosis - Decoding failure",
    session: "Session VII: Innovations and Future Directions",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "3:10 PM - 4:20 PM"
  },
  {
    name: "Dr. Vivekananda",
    topic: "Profundoplasty - Am I not important!",
    session: "Session V: Techniques",
    day: "Day 2 - Saturday, 14th March 2026",
    time: "12:30 PM - 1:30 PM"
  }
];

function Speakers() {
  const [searchTerm, setSearchTerm] = useState('');
  
  // Filter and sort speakers
  const filteredSpeakers = speakersData
    .filter(speaker => 
      speaker.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      speaker.topic.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <div className="header-container">
          <div className="logo-container">
            <Link to="/">
              <img 
                src={siteConfig.logo.path} 
                alt={siteConfig.logo.alt} 
                className="logo"
              />
            </Link>
          </div>
          <nav className="nav-container">
            <ul className="navigation">
              <li>
                <Link to="/" className="nav-link">HOME</Link>
              </li>
              <li>
                <Link to="/faculty" className="nav-link">FACULTY</Link>
              </li>
              <li>
                <Link to="/#committee" className="nav-link">COMMITTEE</Link>
              </li>
              <li>
                <Link to="/#program" className="nav-link">PROGRAM SCHEDULE</Link>
              </li>
              <li>
                <Link to="/#workshop" className="nav-link">WORKSHOP</Link>
              </li>
              <li>
                <Link to="/#registration" className="nav-link">REGISTRATION</Link>
              </li>
              <li>
                <Link to="/#about" className="nav-link">ABOUT US</Link>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      
      <div className="speakers-page">
      <div className="speakers-hero">
        <h1 className="speakers-main-title">Conference Faculty</h1>
        <p className="speakers-subtitle">Distinguished speakers from leading institutions</p>
      </div>

      <div className="speakers-container">
        <div className="search-section">
          <div className="search-wrapper">
            <input
              type="text"
              placeholder="Search by speaker name or topic..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <span className="search-icon">🔍</span>
          </div>
          <p className="results-count">
            {filteredSpeakers.length} {filteredSpeakers.length === 1 ? 'speaker' : 'speakers'} found
          </p>
        </div>

        <div className="speakers-grid">
          {filteredSpeakers.map((speaker, index) => (
            <div key={index} className="speaker-card">
              <div className="speaker-header">
                <h3 className="speaker-name">{speaker.name}</h3>
                <span className="speaker-badge">{speaker.day.split(' - ')[0]}</span>
              </div>
              <div className="speaker-details">
                <div className="detail-row">
                  <span className="detail-icon">💬</span>
                  <p className="speaker-topic">{speaker.topic}</p>
                </div>
                <div className="detail-row">
                  <span className="detail-icon">📋</span>
                  <p className="speaker-session">{speaker.session}</p>
                </div>
                <div className="detail-row">
                  <span className="detail-icon">📅</span>
                  <p className="speaker-day">{speaker.day}</p>
                </div>
                <div className="detail-row">
                  <span className="detail-icon">🕐</span>
                  <p className="speaker-time">{speaker.time}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredSpeakers.length === 0 && (
          <div className="no-results">
            <p>No speakers found matching "{searchTerm}"</p>
            <button onClick={() => setSearchTerm('')} className="clear-search-btn">
              Clear Search
            </button>
          </div>
        )}
      </div>
    </div>
    </div>
  );
}

export default Speakers;